import {search} from '@sail/icons/react/Icon';
import {Icon, view, tokens} from '@sail/ui';
import {Text} from 'src/v2/components/common';
import {message, useIntl} from '@sail/intl';

const messages = {
  search: message({
    id: 'crypto.payins.v2.wallet_select.search',
    description: 'Label for the search item in the wallet select grid',
    defaultMessage: 'Search',
  }),
};

export const SearchItem = () => {
  const intl = useIntl();

  return (
    <view.div
      css={{
        stack: 'y',
        gap: 'small',
        alignX: 'center',
        width: '85px',
        borderRadius: 'small',
        ':hover': {
          backgroundColor: tokens.color.neutral[50].toString(),
        },
        padding: '12px 4px 8px 4px',
      }}
    >
      <view.div
        css={{
          stack: 'x',
          width: '44px',
          height: '44px',
          borderRadius: 'large',
          backgroundColor: 'offset',
          alignX: 'center',
          alignY: 'center',
        }}
      >
        <Icon icon={search} size="xsmall" />
      </view.div>
      <Text type="caption" css={{textAlign: 'center'}}>
        {intl.formatMessage(messages.search)}
      </Text>
    </view.div>
  );
};
